import type { ArcgisMap } from '@arcgis/map-components/components/arcgis-map';

import { untracked } from '@angular/core';
import Point from '@arcgis/core/geometry/Point';

import type { Map2 } from './map-2';

import { CalculatePopoverPosition } from './calculate-popover-position';

// Positions the popover for listings hovered from outside the map (e.g. the sidebar list), which have no hit-test screen point of their own.
export function ListingHoveredFromList(this: Map2): void {
  const _listing = this.stateService.hoveredListing();
  if (!_listing) {
    return;
  }

  untracked(() => {
    if (_listing.id === this.hoveredListingId) {
      return;
    }

    const _mapEl = this.mapElement()?.nativeElement as ArcgisMap | undefined;
    if (!_mapEl) {
      return;
    }

    const _point = new Point({
      latitude: Number(_listing.geo.coordinates[1]),
      longitude: Number(_listing.geo.coordinates[0]),
    });

    const _position = CalculatePopoverPosition(_mapEl, _point);
    if (!_position) {
      return;
    }

    this.hoveredListingId = _listing.id;
    this.listingPopoverLeft.set(_position.left);
    this.listingPopoverTop.set(_position.top);
  });
}
